import { render, staticRenderFns } from "./paymentType3.vue?vue&type=template&id=03346cd8"
import script from "./paymentType3.vue?vue&type=script&lang=js"
export * from "./paymentType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports